/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_these_obstacles_slow_your_growth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces obstacles freinent votre croissance. Il est temps de les transformer en opportunités.`)
};

const en_these_obstacles_slow_your_growth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These obstacles are slowing down your growth. It's time to turn them into opportunities.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const these_obstacles_slow_your_growth = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.these_obstacles_slow_your_growth(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("these_obstacles_slow_your_growth", locale)
	if (locale === "fr") return fr_these_obstacles_slow_your_growth(inputs)
	return en_these_obstacles_slow_your_growth(inputs)
};